import naja from "naja";
import autocomplete from 'autocompleter';
import Form from './Form';

export default class OrderCart {

    static init() {
        this.initSearch();
        this.initProductCount();
        const scope = this;

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet--cartFormSnippet') {
                Form.handleFixedLabel();
                scope.initSearch();
                scope.initProductCount();
            }
        });
    }

    static initSearch() {
        var input = document.getElementById("fastProductName");
        var hiddenInput = document.getElementById('fastProductId');

        if(input) {
            autocomplete({
                input: input,
                fetch: function(text, update) {
                    text = text.toLowerCase();
                    // you can also use AJAX requests instead of preloaded data
                    fetch(window.productsLink+'&phrase='+text)
                        .then(res => res.json())//response type
                        .then(data => update(data.result)); //log the data;
                },
                onSelect: function(item) {
                    input.value = item.label;
                    hiddenInput.value = item.value;
                }
            });
        }
    }

    static initProductCount() {
        var inputs = document.getElementsByClassName('jsCounterInput');

        if (inputs.length > 0) {
            inputs.forEach(input => {
                input.addEventListener('change', () => {
                    naja.makeRequest('GET', '/kosik?productId='+input.dataset.id+'&quantity='+input.value+'&do=setProductQuantity');
                });
            });
        }
    }
}
